import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSortArrowUp = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 12,
	height: 12,
	viewBox: "0 0 6 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M0.75 2.95339L3.53542 0.167968L6.33542 2.96797L5.72292 3.58047L3.97292 1.83047L3.97292 11.2951L3.09792 11.2951L3.09792 1.83047L1.3625 3.56589L0.75",
		fill: "#1D1D1D"
	})
});
export default SvgSortArrowUp;
